import {IMultiSelectSettings, IMultiSelectTexts} from "angular-2-dropdown-multiselect";

export class DropdownOptions {

  // Multi select dropdown Text configuration
  public static msTexts: IMultiSelectTexts = {
    defaultTitle: "Select Multiple Options",
    checkAll: "Select All",
    uncheckAll: "Deselect All"
  };

  // Single select dropdown Text configuration
  public static ssTexts: IMultiSelectTexts = {
    defaultTitle: "Select Option"
  };

  // Multi select dropdown Settings configuration
  public static msSettings: IMultiSelectSettings = {
    enableSearch: true,
    buttonClasses: "btn btn-default btn-block",
    dynamicTitleMaxItems: 20,
    showCheckAll: true,
    showUncheckAll: true,
    displayAllSelectedText: true
  };

  // Single select dropdown Settings configuration
  public static ssSettings: IMultiSelectSettings = {
    selectionLimit: 1,
    autoUnselect: true,
    closeOnSelect: true,
    checkedStyle: "fontawesome"
  };

  static getMsSettings(){
    return Object.assign({}, DropdownOptions.msSettings)
  }

  static getMsTexts(){
    return Object.assign({}, DropdownOptions.msTexts)
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/dropdown-options.ts